interface Props {
  score: number; // 1-10
  size?: number;
}

export const FitScoreRing = ({ score, size = 96 }: Props) => {
  const pct = Math.max(0, Math.min(10, score)) / 10;
  const stroke = 8;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - pct * c;

  const colorVar =
    score >= 8 ? "hsl(var(--success))" :
    score >= 5 ? "hsl(var(--primary))" :
    "hsl(var(--warning))";

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="hsl(var(--muted))"
          strokeWidth={stroke}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke={colorVar}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
          fill="none"
          style={{ transition: "stroke-dashoffset 0.8s ease-out" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-2xl font-bold tabular-nums">{score.toFixed(1)}</span>
        <span className="text-[10px] uppercase tracking-wider text-muted-foreground">/ 10</span>
      </div>
    </div>
  );
};
